export const xCrossCircleIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"
     fill="none">
  <path
    d="M12.5003 0.731445C6.02561 0.731445 0.791992 5.96507 0.791992 12.4398C0.791992 18.9145 6.02561 24.1481 12.5003 24.1481C18.975 24.1481 24.2086 18.9145 24.2086 12.4398C24.2086 5.96507 18.975 0.731445 12.5003 0.731445ZM12.5003 21.8064C7.33695 21.8064 3.13366 17.6031 3.13366 12.4398C3.13366 7.2764 7.33695 3.07311 12.5003 3.07311C17.6637 3.07311 21.867 7.2764 21.867 12.4398C21.867 17.6031 17.6637 21.8064 12.5003 21.8064ZM16.7036 6.58561L12.5003 10.7889L8.29703 6.58561L6.64616 8.23648L10.8494 12.4398L6.64616 16.6431L8.29703 18.2939L12.5003 14.0906L16.7036 18.2939L18.3545 16.6431L14.1512 12.4398L18.3545 8.23648L16.7036 6.58561Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
